import { Pencil } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { languages } from "@/data/languages";
import { useSettingsState } from "@/context/SettingsStateContext";
import useSettingLanguage from "@/hooks/useSettingLanguage";

export default function LanguageCard() {
  const { websiteLanguage } = useSettingsState();
  const { handleLanguageChange, handleCustomLanguageSubmit, handleEditCustomLanguage } =
    useSettingLanguage();

  return (
    <Card id="language">
      <CardHeader>
        <CardTitle>Website language</CardTitle>
        <CardDescription>
          Set the primary language for your website content
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="language">Content Language</Label>
          <div className="flex gap-2">
            <select
              id="language"
              value={
                languages.some((l) => l.code === websiteLanguage)
                  ? websiteLanguage
                  : "other"
              }
              onChange={(e) => handleLanguageChange(e.target.value)}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.name}
                </option>
              ))}
            </select>
          </div>
          {!languages.some((l) => l.code === websiteLanguage) && (
            <div className="mt-2 p-3 border rounded-md bg-muted/30">
              <p>
                Using custom language code:{" "}
                <span className="font-medium">{websiteLanguage}</span>
              </p>
              <Button
                variant="outline"
                size="sm"
                className="mt-2 h-8 text-xs"
                onClick={handleEditCustomLanguage}
              >
                <Pencil className="h-3 w-3 mr-1" />
                Edit Custom Language Code
              </Button>
            </div>
          )}
          <p className="text-sm text-muted-foreground">
            This affects how content is generated, including capitalization rules for
            headings and language-specific formatting.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
